var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgComment(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.864,
    height: 24.984,
    viewBox: "0 0 26.864 24.984",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "comment",
    transform: "translate(0.249 1.582)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14004",
    "data-name": "Path 14004",
    d: "M22.74-1.332H3.625A3.629,3.629,0,0,0,0,2.293v11.7a3.629,3.629,0,0,0,3.612,3.625v5.308l7.629-5.308h11.5a3.629,3.629,0,0,0,3.625-3.625V2.293A3.629,3.629,0,0,0,22.74-1.332ZM24.82,13.99a2.082,2.082,0,0,1-2.08,2.08H10.756l-5.6,3.9v-3.9H3.625a2.082,2.082,0,0,1-2.08-2.08V2.293A2.082,2.082,0,0,1,3.625.213H22.74a2.082,2.082,0,0,1,2.08,2.08Zm0,0",
    fill: "#f7f7f7",
    stroke: "#fff",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14005",
    "data-name": "Path 14005",
    d: "M171.293,131.172h12.252v1.545H171.293Zm0,0",
    transform: "translate(-164.236 -127.046)",
    fill: "#f7f7f7",
    stroke: "#fff",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14006",
    "data-name": "Path 14006",
    d: "M171.293,211.172h12.252v1.545H171.293Zm0,0",
    transform: "translate(-164.236 -203.75)",
    fill: "#f7f7f7",
    stroke: "#fff",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14007",
    "data-name": "Path 14007",
    d: "M171.293,291.172h12.252v1.545H171.293Zm0,0",
    transform: "translate(-164.236 -280.455)",
    fill: "#f7f7f7",
    stroke: "#fff",
    strokeWidth: 0.5
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgComment);
export default __webpack_public_path__ + "static/media/comment.48fe8b238f3c3ea93f7e934d3dd03eb3.svg";
export { ForwardRef as ReactComponent };